const getCustomerProfileBaseUrl = (usesWarpAuth: boolean) =>
  `${usesWarpAuth ? process.env.NEXT_PUBLIC_WARP_BASE_URL : process.env.NEXT_PUBLIC_APIM_BASE_URL}${
    process.env.NEXT_PUBLIC_API_URL_PREFIX_CUSTOMER_PROFILE
  }`;

const getDealerPreferencesBaseUrl = (usesWarpAuth: boolean) =>
  `${usesWarpAuth ? process.env.NEXT_PUBLIC_WARP_BASE_URL : process.env.NEXT_PUBLIC_APIM_BASE_URL}${
    process.env.NEXT_PUBLIC_API_URL_PREFIX_BASE_URL_PREFERENCES
  }`;

const getConsentBaseUrl = (usesWarpAuth: boolean) =>
  `${usesWarpAuth ? process.env.NEXT_PUBLIC_WARP_BASE_URL : process.env.NEXT_PUBLIC_APIM_BASE_URL}${
    process.env.NEXT_PUBLIC_API_URL_PREFIX_CONSENT
  }`;

const getBiometricAuthBaseUrl = (usesWarpAuth: boolean) =>
  `${usesWarpAuth ? process.env.NEXT_PUBLIC_WARP_BASE_URL : process.env.NEXT_PUBLIC_APIM_BASE_URL}${
    process.env.NEXT_PUBLIC_API_URL_PREFIX_BASE_URL_BIOMETRIC_AUTH
  }`;

const getWebAuthnBaseUrl = (usesWarpAuth: boolean) =>
  `${usesWarpAuth ? process.env.NEXT_PUBLIC_WARP_BASE_URL : process.env.NEXT_PUBLIC_APIM_BASE_URL}${
    process.env.NEXT_PUBLIC_API_URL_PREFIX_BASE_URL_WEBAUTHN
  }`;

const getLegalBaseUrl = (usesWarpAuth: boolean) =>
  `${usesWarpAuth ? process.env.NEXT_PUBLIC_WARP_BASE_URL : process.env.NEXT_PUBLIC_APIM_BASE_URL}${
    process.env.NEXT_PUBLIC_API_URL_PREFIX_BASE_URL_LEGAL
  }`;

export const customerProfileApiBaseUrl = () => {
  const usesWarpAuth = process.env.NEXT_PUBLIC_WARP_AUTH_ENABLED === 'true';
  return {
    withCredentials: usesWarpAuth,
    baseUrl: getCustomerProfileBaseUrl(usesWarpAuth),
  };
};

export const dealerPreferencesApiBaseUrl = () => {
  const usesWarpAuth = process.env.NEXT_PUBLIC_WARP_AUTH_ENABLED === 'true';
  return {
    withCredentials: usesWarpAuth,
    baseUrl: getDealerPreferencesBaseUrl(usesWarpAuth),
  };
};

export const consentApiBaseUrl = () => {
  const usesWarpAuth = process.env.NEXT_PUBLIC_WARP_AUTH_ENABLED === 'true';
  return {
    withCredentials: usesWarpAuth,
    baseUrl: getConsentBaseUrl(usesWarpAuth),
  };
};

export const biometricAuthApiBaseUrl = () => {
  const usesWarpAuth = process.env.NEXT_PUBLIC_WARP_AUTH_ENABLED === 'true';
  return {
    withCredentials: usesWarpAuth,
    baseUrl: getBiometricAuthBaseUrl(usesWarpAuth),
  };
};

export const webAuthnApiBaseUrl = () => {
  const usesWarpAuth = process.env.NEXT_PUBLIC_WARP_AUTH_ENABLED === 'true';
  return {
    withCredentials: usesWarpAuth,
    baseUrl: getWebAuthnBaseUrl(usesWarpAuth),
  };
};

export const legalApiBaseUrl = () => {
  const usesWarpAuth = process.env.NEXT_PUBLIC_WARP_AUTH_ENABLED === 'true';
  return {
    withCredentials: usesWarpAuth,
    baseUrl: getLegalBaseUrl(usesWarpAuth),
  };
};
